import { useState, FC, useContext } from "react";
import Button from "Components/Button";
import { Wrapper, PostEventWrapper, Typography, Info} from "./CreateEvent.styled";
import { useRouter } from "next/router";
import { AuthContext } from "common/context/Auth";
import LoginButton from "common/Auth/AuthButton";

interface Props {
  text: boolean;
}

const CreateEvent: FC<Props> = ({ text }) => {
  const router = useRouter();
  const { session } = useContext<any>(AuthContext);
  if (!session) {
  }
  return (
    <Wrapper>
      <PostEventWrapper>
          {text && (
            <>
              <Typography>Post Event</Typography>
              <Info>
                Create and post your event online. It’s fast, easy and free.
              </Info>
            </>
          )}
        {session ? (
          <Button
            handleClick={() => router.push("whats-on/create")}
            buttonStyles="primary"
          >
            <span>Post event</span>
          </Button>
          ) : (
          <LoginButton type="login" className="event-login">Post event</LoginButton> 
          )
        }
      </PostEventWrapper>
    </Wrapper>
  );
};

export default CreateEvent;
